module.exports = __webpack_public_path__ + "static/intercom-f5050b616acd09022c079332cc5eefcb.png";